<template>
  <LimitedCompanies />
</template>

<script>
import LimitedCompanies from '@/components/LimitedCompanies'

export default {
  components: {
    LimitedCompanies
  }
}
</script>

<style></style>
